import styled from '@emotion/styled'
import { Card } from '@material-ui/core'

export const LoginContainer = styled.div`
  background-color: #3c99e7;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`

export const LoginForm = styled(Card)`
  background-color: #fff;
  padding: 20px;
  width: 280px;
`

export const ButtonContainer = styled.div`
  padding-top: 12px;
`
